import React, { useState } from 'react';
import Select from 'react-select';
import style from './testDropdown.module.scss';

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

export const TestDropdown = () => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (chosenOption) => {
    setSelectedOption(chosenOption);
  };

  return (
    <React.Fragment>
      <div className={style.greenBackground}>
        Selected option - Label: {selectedOption?.label} - Value:{' '}
        {selectedOption?.value}
      </div>
      <Select
        value={selectedOption}
        onChange={handleChange}
        options={options}
      />
    </React.Fragment>
  );
};
